import React from "react";
import {useEventContext} from "../../../../context";
import {Button, Col, Grid, Panel, Row} from "react-bootstrap";

export default () => {
    const {event} = useEventContext();
    const {eventPassword} = event;
    const hasEpisodes = event.stream.reduce((has, stream) => has || (stream.episode.length > 0), false);

    const modules = [{
        title: 'Список зрителей',
        url: `/api/cp/event/${eventPassword}/client.xlsx?watches=0`
    }, {
        title: 'Комментарии',
        url: event.moduleComment.enabled && `/api/cp/event/${eventPassword}/comment/archive.xlsx`
    }, {
        title: 'Вопросы',
        url: event.moduleQuestion.enabled && `/api/cp/event/${eventPassword}/question/archive.xlsx`,
    }, {
        title: 'Опросы',
        url: `/api/cp/event/${eventPassword}/statistic/polls.xlsx`,
    // }, {
    //     title: 'Действия зрителей',
    //     url: `/api/cp/event/${eventPassword}/client/tracking.xlsx`,
    }, {
        title: 'Билеты',
        url: event.private && `/api/cp/event/${eventPassword}/ticket.xlsx`,
    }, {
        title: 'Сессии просмотра',
        url: `/api/cp/event/${eventPassword}/statistic/watch.xlsx`,
    }, {
        title: 'Эпизоды',
        url: hasEpisodes && `/api/cp/event/${eventPassword}/episode.xlsx`,
    }, {
        title: 'Призы',
        url:  event.moduleShop.enabled &&  `/api/cp/event/${event.eventKey}/module/shop/product/orders/report.xlsx`,
    }];

    return (
        <Grid>
            <Row>
                {modules.filter(({url}) => !!url).map(({title, url}, index) => (
                    <Col key={index} xs={12} sm={6} md={4} lg={4}>
                        <Panel>
                            <Panel.Heading>
                                {title}
                            </Panel.Heading>
                            <Panel.Body>
                                <p>
                                    <Button href={url} download>Скачать</Button>
                                </p>
                            </Panel.Body>
                        </Panel>
                    </Col>
                ))}
            </Row>
        </Grid>
    )
}
